import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { ComponentCanDeactivate } from '@app/core/guards';
import { RoleService } from '@app/core/services';
import { NotificationModuleEnum } from '@app/enums/system-settings';
import { NotificationModel } from '@app/models/system-settings';
import { RoleModel } from '@app/models/system-settings/role.model';
import { NotificationsGridComponent } from './components/notifications-grid/notifications-grid.component';
import { NotificationService } from './services/notification.service';

@Component({
    selector: 'ss-notifications-setup',
    templateUrl: './notifications-setup.component.html',
    standalone: true,
    imports: [
        MatTabsModule,
        NotificationsGridComponent,
        MatExpansionModule,
    ],
})
export class NotificationsSetupComponent implements OnInit, ComponentCanDeactivate {
	// @ViewChild('hcmGrid') hcmGrid: NotificationsGridComponent;
	@ViewChild('fundGrid') fundGrid: NotificationsGridComponent;
	// @ViewChild('faGrid') faGrid: NotificationsGridComponent;
	// @ViewChild('budgetGrid') budgetGrid: NotificationsGridComponent;
	@ViewChild('portalSystemGrid') portalSystemGrid: NotificationsGridComponent;
	@ViewChild('portalEmployeeGrid') portalEmployeeGrid: NotificationsGridComponent;

	notifications: NotificationModel[] = [];
	// hcmNotifications: NotificationModel[] = [];
	fundNotifications: NotificationModel[] = [];
	// faNotifications: NotificationModel[] = [];
	// budgetNotifications: NotificationModel[] = [];
	portalSystemNotifications: NotificationModel[] = [];
	portalEmployeeNotifications: NotificationModel[] = [];
	roles: RoleModel[] = [];

	constructor(private readonly notificationService: NotificationService, private readonly roleService: RoleService) {}

	@HostListener('window:beforeunload')
	canDeactivate = (): boolean =>
		// this.hcmGrid.CanDeactivate() &&
		this.fundGrid.CanDeactivate() &&
		// this.faGrid.CanDeactivate() &&
		// this.budgetGrid.CanDeactivate() &&
		this.portalSystemGrid.CanDeactivate() &&
		this.portalEmployeeGrid.CanDeactivate();

	ngOnInit(): void {
		this.loadNotifications();
		this.loadRoles();
	}

	private loadNotifications() {
		this.notificationService.getList().subscribe((data: any[]) => {
			this.notifications = data;
			// this.hcmNotifications = this.notifications.filter((n) => n.ModuleId === NotificationModuleEnum.HCM);
			this.fundNotifications = this.notifications.filter((n) => n.ModuleId === NotificationModuleEnum.Fund);
			// this.faNotifications = this.notifications.filter((n) => n.ModuleId === NotificationModuleEnum.FixedAssets);
			// this.budgetNotifications = this.notifications.filter((n) => n.ModuleId === NotificationModuleEnum.BudgetBuilder);
			this.portalSystemNotifications = this.notifications.filter(
				(n) => n.ModuleId === NotificationModuleEnum.EmployeePortal && n.Employee === false
			);
			this.portalEmployeeNotifications = this.notifications.filter((n) => n.ModuleId === NotificationModuleEnum.EmployeePortal && n.Employee);
		});
	}

	private loadRoles() {
		this.roleService.getRoleList().subscribe((data) => (this.roles = data));
	}
}
